import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import MessageIcon from "@mui/icons-material/Message";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MailIcon from "@mui/icons-material/Mail";
import ListAltIcon from "@mui/icons-material/ListAlt";

const AdminSidebar = ({ sidebartab, handlesidebartab }) => {
  let navigate = useNavigate();

  const [isMailExpanded, setIsMailExpanded] = useState(false);

  const toggleExpansion = (type) => {
    if (type === "Mail") {
      setIsMailExpanded(!isMailExpanded);
    }
  };

  return (
    <div
      className="account_sidebar"
      // style={{ width: "100%", height: "100%", boxSizing: "border-box" }}
    >
      <div
        className="account_sidebar_inn"
        style={{
          width: "100%",
          height: "100%",
          //overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
        <div className="side-menu" >
          <div className="row">
            <nav
              className="navbar navbar-expand-lg navbar-light bg-light"
              style={{ width: "100%", backgroundColor: "#fff !important" }}
            >
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#bs-sidebar-navbar-collapse-1"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="side-menu-container">
                <ul className="nav navbar-nav">
                  {/* 1. PROFILE */}
                  <li
                    className={`account_sidebarelementcontainer ${
                      sidebartab === "edit" ? "activeaccount" : ""
                    }`}
                    onClick={() => handlesidebartab("edit")}
                  >
                    <a className="nav-link">
                      <span style={{ padding: "inherit" }}>
                        <PersonIcon />
                      </span>{" "}
                      Profile
                    </a>
                  </li>

                  {/* 2. MAIL DROPDOWN */}
                  <li className="nav-item dropdown">
                    <div
                      onClick={() => toggleExpansion("Mail")}
                      className="nav-link"
                      data-toggle="collapse"
                      href="#dropdown-lvl1"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <a>
                        <span style={{ padding: "15px 8px" }}>
                          <MailIcon />
                        </span>
                        Mail
                      </a>
                      <a>
                        <div href="#dropdown-lvl1">
                          {isMailExpanded ? (
                            <span style={{ position: "relative" }}>
                              <span
                                style={{
                                  position: "absolute",
                                  width: "50px",
                                  height: "50px",
                                  zIndex: 3,
                                }}
                                data-toggle="collapse"
                                href="#dropdown-lvl1"
                              ></span>
                              <ExpandLessIcon />
                            </span>
                          ) : (
                            <span style={{ position: "relative" }}>
                              <span
                                data-toggle="collapse"
                                style={{
                                  position: "absolute",
                                  width: "50px",
                                  height: "50px",
                                  zIndex: 3,
                                }}
                                href="#dropdown-lvl1"
                              ></span>
                              <ExpandMoreIcon />
                            </span>
                          )}
                        </div>
                      </a>
                    </div>
                    <div id="dropdown-lvl1" className="panel-collapse collapse">
                      <div className="panel-body">
                        <ul className="nav navbar-nav">
                          <li
                            className={`account_sidebarelementcontainer ${
                              sidebartab === "message" ? "activeaccount" : ""
                            }`}
                            onClick={() => handlesidebartab("message")}
                          >
                            <a className="nav-link">
                              <span style={{ padding: "inherit" }}>
                                <MoveToInboxIcon />
                              </span>
                              Inbox
                            </a>
                          </li>

                          <li
                            className={`account_sidebarelementcontainer ${
                              sidebartab === "inbox" ? "activeaccount" : ""
                            }`}
                            onClick={() => handlesidebartab("inbox")}
                          >
                            <a className="nav-link">
                              <span style={{ padding: "inherit" }}>
                                <MessageIcon />
                              </span>
                              Sent
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>

                  {/* 3. LEAD LIST (Direct Navigation) */}
                  <li
                    className={`account_sidebarelementcontainer ${
                    sidebartab === "leadlist" ? "activeaccount" : ""
                    }`}
                    onClick={() => navigate("/leads_list")}
                        >
                    <a className="nav-link">
                    <span style={{ padding: "inherit" }}>
                        <ListAltIcon />
                    </span>{" "}
                    Lead List
                    </a>
                </li>

                <li
                className={`account_sidebarelementcontainer ${
                sidebartab === "clientlist" ? "activeaccount" : ""
                }`}
                onClick={() => navigate("/clients_list")}
                    >
                <a className="nav-link">
                <span style={{ padding: "inherit" }}>
                    <PersonIcon /> 
                </span>{" "}
                Clients
                </a>
              </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSidebar;